import authReducer from './auth-reducer';
import { combineReducers } from 'redux';
import companyReducer from './company-reducer';
import companyRegistrationRequest from './company-registration-request-reducer';
import companyWebsiteRequest from './company-website-request-reducer';
import customersReducer from './customers-reducer';
import deliveryReducer from './delivery-reducer';
import fleetReducer from './fleet-reducer';
import globalReducer from './global-reducer';
import parcelDeliveryReducer from './parcel-delivery-reducer';
import { persistReducer } from 'redux-persist';
import pickupPointsReducer from './pickup-points-reducer';
import productPurchaseReducer from './product-purchase-reducer';
import servicesReducer from './services-reducer';
import storage from 'redux-persist/lib/storage';
import userReducer from './user-reducer';
import usersReducer from './users-reducer';
import vehicleReducer from './vehicle-reducer';

export * from './auth-reducer';
export * from './user-reducer';
export * from './company-reducer';
export * from './vehicle-reducer';
export * from './users-reducer';
export * from './customers-reducer';
export * from './fleet-reducer';
export * from './delivery-reducer';
export * from './company-registration-request-reducer';
export * from './company-website-request-reducer';
export * from './product-purchase-reducer';
export * from './services-reducer';
export * from './pickup-points-reducer';
export * from './parcel-delivery-reducer';
export * from './global-reducer';

const authPersistConfig = {
    key: 'company',
    storage: storage,
    whitelist: ['is_company', 'company']
  };

export const rootReducer = combineReducers({
    authReducer,
    userReducer,
    companyReducer: persistReducer(authPersistConfig, companyReducer),
    vehicleReducer,
    usersReducer,
    customersReducer,
    fleetReducer,
    deliveryReducer,
    companyRegistrationRequest,
    companyWebsiteRequest,
    productPurchaseReducer,
    servicesReducer,
    pickupPointsReducer,
    parcelDeliveryReducer,
    globalReducer
});